import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["tag"];

  connect() {
    console.log("connected taglist_controller.js");
  }
  select(e) {
    if (e.target.dataset["taglist-target"] == "check") {
      return true;
    }
    let tag = event.target.closest(".tag");
    let input = tag.querySelector('input[type="checkbox"]');
    input.checked = !input.checked;
  }
  locked(e) {
    e.preventDefault();
    e.stopPropagation();
    let lockmsg = e.target.dataset.lockmsg;
    if(lockmsg == undefined) {
      alert("Dieser Tag ist gesperrt und kann nicht bearbeitet werden.");
    } else {
      alert(lockmsg);
    }
  }
}
